import React from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";

interface FooterLink {
    key: string;
    label: string;
    href: string;
}

interface FooterProps {
    version: string;
}

const Footer: React.FC<FooterProps> = ({ version }) => {
    const { t } = useTranslation("common");

    const legalLinks: FooterLink[] = [
        {
            key: "privacy",
            label: t("footer.links.privacy"),
            href: t("footer.links.privacy_url"),
        },
        {
            key: "imprint",
            label: t("footer.links.imprint"),
            href: t("footer.links.imprint_url"),
        },
        {
            key: "terms",
            label: t("footer.links.terms"),
            href: t("footer.links.terms_url"),
        },
        {
            key: "support",
            label: t("footer.links.support"),
            href: t("footer.links.support_url"),
        },
    ];

    return (
        <footer className="app-footer">
            <Container className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-center">
                <span className="text-muted small">{t("footer.version", { version })}</span>
                <div className="d-flex flex-wrap gap-3">
                    {legalLinks.map((link) => (
                        <a
                            key={link.key}
                            className="app-footer-link text-muted small"
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {link.label}
                        </a>
                    ))}
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
